import { useContext, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import ButtonLoading from "../../components/animations/ButtonLoading";
import APIService from "../../services/APIService";
import SimpleContext from "../../context/SimpleContext";

const Container = styled.div`
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #00000027;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  min-height: 100vh;
`;
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  width: 90%;

  background-color: #1a2c38;
  background-color: var(--bg-200);
  position: relative;
  overflow: auto; /* omogućava skrolanje unutar div-a */
  -webkit-overflow-scrolling: touch;

  padding: 20px 0;
  border-radius: 14px;
  @media (min-width: 768px) {
    width: 500px;
    min-height: auto;
  }
`;
const FormWrapper = styled.div`
  min-width: 90%;
  max-width: 90%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const FormContainer = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    width: 500px;
  }
`;
const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  //gap: 8px;
  margin: 10px 0;
`;

const Title = styled.h1`
  font-size: var(--font-size-xlarge);
  text-align: center;
  font-weight: 400;
  padding: 0;
  margin: 0;
  color: var(--text-200);
  text-transform: uppercase;
  margin-bottom: var(--spacing-sm);
  padding-bottom: var(--spacing-xs);

  border-bottom: 1px solid var(--bg-300);
`;
const Subtitle = styled.div`
  font-size: var(--font-size-small);
  color: var(--text-100);
  text-align: center;

  margin-bottom: var(--spacing-xl);
`;

const Input = styled.input`
  outline: none;
  padding: var(--spacing-sm) 0 var(--spacing-sm) var(--spacing-xs);
  border: 1px solid #ccc;
  width: calc(100% - 8px);
  font-size: var(--font-size-small);
  color: var(--text-200);
  background-color: var(--bg-100);
  margin: var(--spacing-xxs) 0 var(--spacing-md) 0;
  ::placeholder {
    font-size: var(--font-size-small);
    color: var(--text-200);
  }
  border-radius: 4px;
`;
const Label = styled.label`
  font-size: var(--font-size-base);
  text-transform: capitalize;
  color: var(--text-200);
  text-align: left;
  min-width: 100%;
`;

const ButtonWrapper = styled.div`
  position: relative; /* Roditeljski kontejner koji omogućava apsolutno pozicioniranje za decu */
  display: inline-block; /* Omogućava kontejneru da se prilagodi veličini sadržaja */
  width: 90%;
  text-align: center;
  margin: var(--spacing-md) 0;
`;
const Button = styled.button`
  width: 100%;
  height: 50px;
  background-color: var(--text-200);
  text-transform: capitalize;
  border-radius: 8px;
  border-color: var(--text-200);
  &:hover {
    background-color: var(--bg-200);
    color: var(--text-200);
  }
`;

const ExitContainer = styled.div`
  display: block;
  position: absolute;
  top: 20px;
  cursor: pointer;
  right: 10%;
`;
const BackContainer = styled(ExitContainer)`
  left: 10%;
`;

const ForgotPassword = ({ setForgotPassword }) => {
  const { t } = useTranslation();
  const { closeLoginPopup } = useContext(SimpleContext);
  const [email, setEmail] = useState("");

  const [isAnimating, setIsAnimating] = useState(false);

  const [errorEmailText, setErrorEmailText] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    APIService.ResetPasswordRequest(email);
  };
  const handleAnimationComplete = () => {
    setIsAnimating(false);
  };

  return (
    <>
      <Container>
        <Wrapper>
          <FormContainer>
            <BackContainer
              onClick={() => {
                setForgotPassword(false);
              }}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 12H18M6 12L11 7M6 12L11 17"
                  stroke="var(--text-100)"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </BackContainer>
            <ExitContainer
              onClick={() => {
                setForgotPassword(false);
                closeLoginPopup();
              }}
            >
              <svg
                width="24px"
                height="24px"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="var(--text-200)"
                  d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
                />
              </svg>
            </ExitContainer>

            <Title>{t("LOGIN.FORGOT_PASSWORD_TITLE")}</Title>
            <Subtitle>{t("LOGIN.FORGOT_PASSWORD_SUBTITLE")}</Subtitle>

            <Form onSubmit={handleSubmit}>
              <FormWrapper>
                <Label htmlFor="email">{t("LABELS.EMAIL")}</Label>
                <Input
                  type="email"
                  id="email"
                  value={email}
                  placeholder={t("PLACEHOLDERS.EMAIL")}
                  onChange={(e) => setEmail(e.target.value.replace(/\s/g, ""))}
                  required
                />
              </FormWrapper>

              <ButtonWrapper>
                <Button type="submit">{t("BUTTONS.RECOVER_PASSWORD")}</Button>
                {isAnimating && (
                  <ButtonLoading
                    isAnimating={isAnimating}
                    onComplete={handleAnimationComplete}
                  />
                )}
              </ButtonWrapper>
            </Form>
          </FormContainer>
        </Wrapper>
      </Container>
    </>
  );
};

export default ForgotPassword;
